<template>
    <div class="DialogReportPaid__Component">
        <div style="width: 1200px;" class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">היסטוריית עריכה לשאלה: {{ name }}</p>
                <button type="button" class="delete" @click="$emit('close')" />
            </header>
            <div v-if="isLoading" class="modal-card-body loading-container">
                <p class="loading-text">טוען היסטוריית עריכות...</p>
            </div>
            <section v-else class="modal-card-body">
                <div class="question-info">
                    <p>
                        השאלה נוצרה על ידי:
                        <span class="question-info-value">{{ creatorUser }}</span>
                    </p>
                    <p>
                        תאריך יצירה:
                        <span class="question-info-value">{{ parseDate(createdDate) }}</span>
                    </p>
                </div>
                <table v-if="appearances.length" id="customers" class="">
                    <tr>
                        <th>בתאריך</th>
                        <th>פעולה</th>
                    </tr>
                    <tr class="row" v-for="appearance, idx in appearances" :key="idx">
                        <td class="column-item">{{ parseDate(appearance.createdDate) }}</td>
                        <td class="column-item">{{ appearance.name }}</td>
                    </tr>
                </table>
                <div v-else>אין היסטוריית עריכות לשאלה זו</div>
            </section>
            <footer class="modal-card-foot">
                <b-button :disabled="isLoading" label="סגור" @click="$emit('close')" />
            </footer>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import LessonService from "../services/LessonService";

export default {
    name: "DialogVideoFeedback",
    props: ["questionId", "name", "creatorUser", "createdDate"],
    components: {
    },
    computed: {
        courseId() {
            return this.store.state.auth.course?.id;
        },
    },
    created() {
        this.loadQuestionLogs();
    },
    data() {
        return {
            isLoading: false,
            appearances: [],
        };
    },
    methods: {
        parseDate(date) {
            return moment(date).format("DD/MM/YYYY HH:mm");
        },
        loadQuestionLogs() {
            this.isLoading = true;
            LessonService.getQuestionLogs(this.questionId)
                .then((r) => {
                    this.appearances = r.data;
                })
                .catch((error) => {
                    this.$message.error(error.response.data.message);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>

<style scoped lang="scss">
.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    gap: 15px;
}

.loading-text {
    color: #666;
    font-size: 1rem;
    font-weight: bold;
    margin: 0;
}
.question-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
}

.question-info-value {
    font-weight: bold;
}

.modal-card {
    height: 600px;
}

.feedbacks__container {
    max-height: 450px;

    .feedback {
        display: flex;
        gap: 10px;
    }
}

#customers tr:nth-child(even) {
    background-color: #f2f2f2;
}

#customers th {
    padding-top: 12px;
    padding-bottom: 12px;
    background-color: #1E9EB8;
    color: white;
}

#customers {
    max-height: 350px;
    overflow: auto;
    margin: 15px 0;
    border-collapse: collapse;
    width: 100%;
}

#customers td,
#customers th {
    border: 1px solid #ddd;
    padding: 8px;
}

table {
    display: flex;
    flex-flow: column;
    width: 100%;
    height: 400px;
}

thead {
    padding-right: 13px;
    flex: 0 0 auto;
}

tbody {
    flex: 1 1 auto;
    display: block;
    overflow-y: auto;
    overflow-x: hidden;
}

tr {
    width: 100%;
    display: table;
    table-layout: fixed;
}
</style>
